import {
  type CreateOccupancyTypeRequest,
  type OccupancyTypeDetail,
  OccupancyTypeDetailSchema,
  type OccupancyTypeListQuery,
  type OccupancyTypeListResponse,
  OccupancyTypeListResponseSchema,
  type UpdateOccupancyTypeRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

export const listOccupancyTypes = async (
  query: OccupancyTypeListQuery,
): Promise<OccupancyTypeListResponse> => {
  const { data } = await apiClient.get<unknown>('/occupancy-types', { params: query });
  return OccupancyTypeListResponseSchema.parse(data);
};

export const getOccupancyType = async (id: string): Promise<OccupancyTypeDetail> => {
  const { data } = await apiClient.get<unknown>(`/occupancy-types/${id}`);
  return OccupancyTypeDetailSchema.parse(data);
};

export const createOccupancyType = async (
  payload: CreateOccupancyTypeRequest,
): Promise<OccupancyTypeDetail> => {
  const { data } = await apiClient.post<unknown>('/occupancy-types', payload);
  return OccupancyTypeDetailSchema.parse(data);
};

export const updateOccupancyType = async (
  id: string,
  payload: UpdateOccupancyTypeRequest,
): Promise<OccupancyTypeDetail> => {
  const { data } = await apiClient.patch<unknown>(`/occupancy-types/${id}`, payload);
  return OccupancyTypeDetailSchema.parse(data);
};

export const deleteOccupancyType = async (id: string): Promise<void> => {
  await apiClient.delete(`/occupancy-types/${id}`);
};

export const bulkDeleteOccupancyTypes = async (
  ids: string[],
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/occupancy-types/bulk-delete', { ids });
  return data;
};

export const bulkSetOccupancyTypesStatus = async (
  ids: string[],
  isActive: boolean,
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/occupancy-types/bulk-set-status', { ids, isActive });
  return data;
};
